import React, { useState } from 'react';
import { 
  TextField, 
  InputAdornment,
  FormHelperText 
} from '@mui/material';
import { Phone, CheckCircle, Error } from '@mui/icons-material';

const PhoneNumberField = ({ value, onChange, onBlur, error, helperText, lang, ...props }) => {
  const [internalError, setInternalError] = useState('');
  const [touched, setTouched] = useState(false);

const validatePhone = (phone) => {
  if (!phone) return lang === 'ar' ? 'رقم الهاتف مطلوب' : 'Phone Number required';
  
  // Remove all non-digit characters except '+'
  let cleanPhone = phone.replace(/[^\d+]/g, '');
  
  // Check if it has a plus sign (international format)
  const hasPlus = cleanPhone.startsWith('+');
  
  // Remove the plus for length check if present
  const digitsOnly = cleanPhone.replace(/\+/g, '');
  
  // Validate length (between 7 and 15 digits, international standard)
  if (digitsOnly.length < 7 || digitsOnly.length > 15) {
    return lang === 'ar'
      ? 'رقم الهاتف يجب أن يحتوي على 7-15 رقم'
      : 'Phone number must contain 7-15 digits';
  }
  
  // If it has plus, it must be followed by at least 1 digit
  if (hasPlus && digitsOnly.length === 0) {
    return lang === 'ar'
      ? 'الرجاء إدخال رمز البلد بعد علامة +'
      : 'Please enter country code after +';
  }
  
  // If no plus, it can start with 0 or not
  return '';
};

  const handleChange = (e) => {
    const input = e.target.value;
    // Allow only numbers and + sign
    const cleanedValue = input.replace(/[^\d+]/g, '');
    onChange(cleanedValue);
    
    if (touched) {
      const validationError = validatePhone(cleanedValue);
      setInternalError(validationError);
    }
  };

  const handleBlurInternal = (e) => {
    setTouched(true);
    const validationError = validatePhone(value);
    setInternalError(validationError);
    if (onBlur) onBlur(e);
  };

  const displayError = error || internalError;
  const isValid = touched && !displayError && value;

  return (
    <>
      <TextField
        {...props}
        placeholder='EX +60 123456789'
        value={value}
        onChange={handleChange}
        onBlur={handleBlurInternal}
        error={!!displayError}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Phone color={isValid ? 'success' : 'disabled'} />
            </InputAdornment>
          ),
          endAdornment: isValid && (
            <InputAdornment position="end">
              <CheckCircle color="success" />
            </InputAdornment>
          ),
        }}
      />
      {displayError && (
        <FormHelperText error>{displayError}</FormHelperText>
      )}
      {helperText && !displayError && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </>
  );
};

export default PhoneNumberField;